import { gql } from '@apollo/client';

export const LEARNING_OBJECTS_QUERY = gql`
    query learningObjects {
        objects {
            edges {
                node {
                    id
                    locales {
                        locale
                        name
                        description
                    }
                    tags
                    format
                    courseCount
                    duration
                    expireAt
                    metadata
                    createdAt
                    updatedAt
                    usedByCourses {
                        id,
                        name
                    }
                }
            }
        }
    }
`;
